import { render, staticRenderFns } from "./music.vue?vue&type=template&id=2eaeb74e&scoped=true"
import script from "./music.vue?vue&type=script&lang=js"
export * from "./music.vue?vue&type=script&lang=js"
import style0 from "./music.vue?vue&type=style&index=0&id=2eaeb74e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaeb74e",
  null
  
)

export default component.exports